export const STRINGS = {
  en: {
    dir: "ltr",
    // header
    brand: "Nebula Prestige",
    tagline: "Curated beauty from the Middle East",
    shop: "Shop",
    home: "Home",
    wallet: "Wallet",
    orders: "Orders",
    admin: "Admin",
    signIn: "Sign in",
    signUp: "Sign up",
    signOut: "Sign out",
    account: "Account",
    cart: "Cart",
    balance: "Balance",
    // home
    heroKicker: "Most requested",
    heroTitle: "The essentials your routine has been waiting for.",
    heroSubtitle: "Handpicked beauty, straight to your door across the Middle East.",
    shopNow: "Shop now",
    exploreOffers: "Explore offers",
    featured: "Featured",
    onOffer: "On Offer",
    seeAll: "See all",
    // categories
    all: "All",
    lips: "Lips",
    eyes: "Eyes",
    face: "Face",
    accessories: "Accessories",
    // shop
    searchPlaceholder: "Search products, brands…",
    brandLabel: "Brand",
    categoryLabel: "Category",
    sortBy: "Sort",
    priceLowHigh: "Price: Low to high",
    priceHighLow: "Price: High to low",
    newest: "Newest",
    noResults: "No products match your filters.",
    // product
    addToCart: "Add to cart",
    outOfStock: "Unavailable",
    description: "Description",
    // cart
    yourCart: "Your cart",
    empty: "Your cart is empty.",
    subtotal: "Subtotal",
    total: "Total",
    checkout: "Checkout",
    remove: "Remove",
    continueShopping: "Continue shopping",
    minOrder: "Minimum order",
    addMore: "Add ${amount} more to place your order",
    // wallet
    walletTitle: "Wallet",
    currentBalance: "Current balance",
    howToTopUp: "How to top up",
    topUpInstructions:
      "Visit our POS in the Middle East to pay in cash. Our team will credit your wallet manually within a few hours.",
    transactions: "Transactions",
    noTransactions: "No transactions yet.",
    // auth
    email: "Email",
    phone: "Phone number",
    phonePlaceholder: "+963933593799",
    password: "Password",
    name: "Name",
    createAccount: "Create account",
    haveAccount: "Already have an account?",
    noAccount: "Don’t have an account?",
    // checkout
    walletBalance: "Wallet balance",
    payWithWallet: "Pay with wallet",
    insufficient: "Insufficient balance. Please top up.",
    shippingAddress: "Shipping address",
    orderPlaced: "Order placed",
    // orders
    orderHistory: "Order history",
    order: "Order",
    status: "Status",
    // admin
    dashboard: "Dashboard",
    products: "Products",
    users: "Users",
    ordersAdmin: "Orders",
    add: "Add",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    disable: "Disable",
    enable: "Enable",
    active: "Active",
    inactive: "Inactive",
    creditWallet: "Credit wallet",
    amount: "Amount",
    note: "Note",
    price: "Price",
    offerPct: "Offer %",
    image: "Image URL",
    quickTopUp: "Quick top-up",
    // misc
    loading: "Loading…",
    close: "Close",
  },
  ar: {
    dir: "rtl",
    brand: "نيبولا برستيج",
    tagline: "منتجات تجميل مختارة من الشرق الأوسط",
    shop: "المتجر",
    home: "الرئيسية",
    wallet: "المحفظة",
    orders: "الطلبات",
    admin: "الإدارة",
    signIn: "تسجيل الدخول",
    signUp: "إنشاء حساب",
    signOut: "تسجيل الخروج",
    account: "الحساب",
    cart: "السلة",
    balance: "الرصيد",
    heroKicker: "الأكثر طلباً",
    heroTitle: "الأساسيات التي كان روتينك ينتظرها.",
    heroSubtitle: "منتجات تجميل مختارة توصل إلى بابك في جميع أنحاء الشرق الأوسط.",
    shopNow: "تسوق الآن",
    exploreOffers: "استكشف العروض",
    featured: "المميّزة",
    onOffer: "العروض",
    seeAll: "عرض الكل",
    all: "الكل",
    lips: "الشفاه",
    eyes: "العيون",
    face: "الوجه",
    accessories: "الإكسسوارات",
    searchPlaceholder: "ابحث عن منتجات، ماركات…",
    brandLabel: "الماركة",
    categoryLabel: "الفئة",
    sortBy: "الترتيب",
    priceLowHigh: "السعر: من الأقل إلى الأعلى",
    priceHighLow: "السعر: من الأعلى إلى الأقل",
    newest: "الأحدث",
    noResults: "لا توجد منتجات مطابقة.",
    addToCart: "أضف إلى السلة",
    outOfStock: "غير متوفر",
    description: "الوصف",
    yourCart: "سلتك",
    empty: "سلتك فارغة.",
    subtotal: "المجموع الفرعي",
    total: "المجموع",
    checkout: "إتمام الشراء",
    remove: "إزالة",
    continueShopping: "متابعة التسوق",
    minOrder: "الحد الأدنى للطلب",
    addMore: "أضف ${amount} أخرى لإتمام الطلب",
    walletTitle: "المحفظة",
    currentBalance: "الرصيد الحالي",
    howToTopUp: "كيفية الشحن",
    topUpInstructions:
      "قم بزيارة نقطة البيع الخاصة بنا في الشرق الأوسط للدفع نقداً. سيقوم فريقنا بشحن محفظتك يدوياً خلال ساعات قليلة.",
    transactions: "المعاملات",
    noTransactions: "لا توجد معاملات بعد.",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    phonePlaceholder: "+963933593799",
    password: "كلمة المرور",
    name: "الاسم",
    createAccount: "إنشاء حساب",
    haveAccount: "لديك حساب بالفعل؟",
    noAccount: "ليس لديك حساب؟",
    walletBalance: "رصيد المحفظة",
    payWithWallet: "الدفع من المحفظة",
    insufficient: "رصيد غير كافٍ. يرجى شحن المحفظة.",
    shippingAddress: "عنوان الشحن",
    orderPlaced: "تم تأكيد الطلب",
    orderHistory: "سجل الطلبات",
    order: "طلب",
    status: "الحالة",
    dashboard: "لوحة التحكم",
    products: "المنتجات",
    users: "المستخدمون",
    ordersAdmin: "الطلبات",
    add: "إضافة",
    edit: "تعديل",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    disable: "تعطيل",
    enable: "تفعيل",
    active: "مفعل",
    inactive: "معطل",
    creditWallet: "شحن المحفظة",
    amount: "المبلغ",
    note: "ملاحظة",
    price: "السعر",
    offerPct: "الخصم %",
    image: "رابط الصورة",
    quickTopUp: "شحن سريع",
    loading: "جارٍ التحميل…",
    close: "إغلاق",
  },
};

export const CATEGORY_KEYS = ["lips", "eyes", "face", "accessories"];
